var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-analytics-chart-container"},[_c('canvas',{ref:"chartCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }